import { sortByTimeFrame } from "constants/global";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import React, { useState } from "react";
import FilterButton from "../FilterDropdown";
import MoreOptionsDropdown from "../flex/shipments/modals/MoreOptionsDropdown";
import { Eye, EyeSlash } from "iconsax-reactjs";
import CurrencyToggle from "../currencyToggle";
import { Button } from "../ui/Button";
import useUserDetails from "hooks/useUserDetails";
import QuestionHelpIcon from "../QuestionHelpIcon";
import { cn } from "lib/utils";
import { currencyToDisplay } from "../flex/utils";

const BoxWrapper = ({ children, className }) => {
  return (
    <div
      className={cn(
        "bg-white box-border h-[152px] flex flex-col gap-2 justify-between !border !border-[#F4F0FF] rounded-2xl !px-4 py-2",
        className
      )}
    >
      {children}
    </div>
  );
};

const FinanceAnalytics = ({ businessId, makePaymentFunc, handleGenerateStatement }) => {
  const [showBalance, setShowBalance] = useState(true);
  const {
    creditBalanceData,
    walletCurrency,
    creditWalletBalance,
    isLoadingCreditBalance,
    isLoadingCreditWallet,
    setRange,
    range,
    newWalletsData,
    isLoadingNewWallets,
    refetchNewWallets,
    currency
  } = useUserDetails();

  return (
    <div className="grid gap-3 grid-cols-1 lg:grid-cols-3 sm:mx-10 md:mx-0">
      <BoxWrapper className="third-step">
        <div className="">
          <CurrencyToggle
            businessId={businessId}
            forCreditWallet
            newWalletsData={newWalletsData}
            isLoadingNewWallets={isLoadingNewWallets}
            refetchNewWallets={refetchNewWallets}
            dropDownClassName="shadow-dropdown2 !left-0 !top-[109%]"
            className="!text-gray-10 !text-base font-light gap-1 flex items-center justify-center w-[115px] !ml-2"
          />
        </div>
        <div className="flex items-center justify-between w-full h-[72px] px-3 bg-secondary-80 rounded-xl">
          <div className="flex flex-col py-2">
            <p className="text-sm font-light text-gray-70">Credit balance</p>

            <p className="flex items-end text-2xl font-normal text-gray-90">
              {!isLoadingCreditWallet ? (
                showBalance ? (
                  <>
                    {currencyToDisplay(walletCurrency ?? currency, creditWalletBalance)}
                    {/* <span className="text-[20px] font-[350] text-[#6F739B]">
                      .{creditWalletBalance?.toFixed(2)?.split(".")[1]}
                    </span> */}
                  </>
                ) : (
                  <p className="text-[40px] font-[450] text-[#161827] ">
                    ••••••••••
                  </p>
                )
              ) : (
                "--"
              )}
              <Button
                onClick={() => setShowBalance((prev) => !prev)}
                variant="ghost"
                className="text-sm font-light text-gray-7"
              >
                {showBalance ? (
                  <EyeSlash size="21" color="#27293F" />
                ) : (
                  <Eye size="21" color="#27293F" />
                )}
              </Button>
            </p>
          </div>
          <button
            variant="ghost"
            size="icon"
            className="text-sm font-light bg-white rounded-full size-10 text-gray-7"
          >
            <MoreOptionsDropdown
              color="#6F00FF"
              options={[
                {
                  label: (
                    <div
                      variant="ghost"
                      className="flex items-center gap-2 p-0"
                    >
                      <span>Make a payment</span>{" "}
                      <QuestionHelpIcon details="Request payment for active invoices, orders and transactions" />
                    </div>
                  ),
                  value: "send-money",
                  className:
                    "flex items-center gap-2 w-full px-4 py-[9px] hover:bg-main-grey/10 hover:rounded-xl font-light text-sm text-[#101828]",
                  action: () => makePaymentFunc(),
                  closeAfterClick: true,
                },
                {
                  label: "Generate statement",
                  value: "delete-beneficiary",
                  className:
                    "flex items-center gap-2 w-full px-4 py-[9px] hover:bg-main-grey/10 hover:rounded-xl font-light text-sm",
                  action: () => handleGenerateStatement(),
                  closeAfterClick: true,
                },
              ]}
              horizontal={true}
            />
          </button>
        </div>
        <div>
          <p className="pl-3 text-sm font-light text-secondary-40">
            <span className="text-gray-70 font-[450]">
              {isLoadingCreditBalance ? "--" : creditBalanceData?.totalOverDueFinance}
            </span>{" "}
            Overdue repayments
          </p>
        </div>
      </BoxWrapper>
      <BoxWrapper>
        <div>
          <p className="text-sm font-light text-gray-70">Active</p>
          <p className="flex items-center text-2xl font-normal text-gray-90">
            {isLoadingCreditBalance ? (
              "--"
            ) : (
              <>
                  {currencyToDisplay(walletCurrency ?? currency, creditBalanceData?.activeFinanceAmount)}
              </>
            )}
          </p>
        </div>
        <div>
          <p className="text-sm font-medium text-secondary-40">
            {isLoadingCreditBalance ? "--" : creditBalanceData?.totalActiveFinance}{" "}
            loans
          </p>
        </div>
      </BoxWrapper>
      <BoxWrapper
        className={`bg-white h-[152px] flex flex-col justify-between !border !border-[#F4F0FF] rounded-lg !px-3 py-2`}
      >
        <div>
          <div className="flex items-center justify-between">
            <p className="text-sm font-light text-gray-70">Disbursed</p>

            <FilterButton
              type="Filter"
              filterList={sortByTimeFrame}
              selected={range}
              onSelect={(data) => setRange(data)}
            />
          </div>
          <p className="flex items-center mt-2 text-2xl font-normal text-gray-90">
            {isLoadingCreditBalance ? (
              "--"
            ) : (
              <>
                  {currencyToDisplay(walletCurrency ?? currency, creditBalanceData?.disbursedFinanceAmount)}
              </>
            )}
          </p>
        </div>
        <div>
          <p className="text-sm font-medium text-secondary-40">
            {isLoadingCreditBalance ? "--" : creditBalanceData?.totalActiveFinance}{" "}
            loans
          </p>
        </div>
      </BoxWrapper>
    </div>
  );
};

export default FinanceAnalytics;
